import { useDispatch } from "react-redux";
import { getAdminActivities } from "../redux/adminActivitiesSlice";
import { useState } from "react";

const AdminActivityFilter = () => {
    const dispatch = useDispatch();
    const [selectedFilter, setSelectedFilter] = useState('filter1');
    const handleClick = (event, filters) => {
        dispatch(getAdminActivities(filters));
        const {id} = event.target;
        setSelectedFilter(id);
    }

    return (
        <div className="flex justify-center md:justify-start gap-4 p-4 rounded-xl">
            <button id="filter1" className={`text-xs cursor-pointer flex whitespace-nowrap py-2 px-4 rounded-xl ${selectedFilter === 'filter1' ? 'text-white bg-[#225424]' : 'bg-white'}`} onClick={(e) => handleClick(e, {selectionKey: '', selectionValue: '', sortBy: '', reverse: '', page: '', pageSize: ''})}>Tutte</button>
            <button id="filter2" className={`text-xs cursor-pointer flex whitespace-nowrap py-2 px-4 rounded-xl ${selectedFilter === 'filter2' ? 'text-white bg-[#225424]' : 'bg-white'}`} onClick={(e) => handleClick(e, {selectionKey: 'isActive', selectionValue: 1, sortBy: '', reverse: '', page: '', pageSize: ''})}>Pubblicate</button>
            <button id="filter3" className={`text-xs cursor-pointer flex whitespace-nowrap py-2 px-4 rounded-xl ${selectedFilter === 'filter3' ? 'text-white bg-[#225424]' : 'bg-white'}`} onClick={(e) => handleClick(e, {selectionKey: 'isActive', selectionValue: 0, sortBy: '', reverse: '', page: '', pageSize: ''})}>Bozza</button>
            {/* <button className="cursor-pointer flex whitespace-nowrap py-2 px-4 bg-white rounded-xl">Scadute</button> */}
        </div>
    )
}

export default AdminActivityFilter;